import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTextIndentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTextIndentRight"><Path fillRule="evenodd" clipRule="evenodd" d="M15 5H2V6.5H15V5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M22.0005 8.59863L16.8984 12L22.0005 15.4014V8.59863Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 11.25H2V12.75H15V11.25Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M15 17.5H2V19H15V17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTextIndentRight;
